import { AdBiddingProvider, IAdBiddingProviderConfig } from '../../../'
import { Errors } from '../../../../../../utils/common'
import { logger } from '../../../../../../utils/common/logger'
import { DOMUtils } from '../../../../../../utils/dom'
import { IAd } from '../../../../ad'
import { AdBiddingBase } from '../base'

interface IWindow {
    googletag: any
    setTimeout: any
    pbjs: any
}

declare let window: IWindow

class Magnite extends AdBiddingBase {
    public requestAds: undefined
    protected URLPath: string
    protected waitForBidder = true
    protected failSafeTimeout = 3500
    protected pbjs: any

    constructor() {
        super()
        this.URLPath = '//micro.rubiconproject.com/prebid/dynamic/14648.js' // TODO '14648' should come from page-data
    }

    public static OnMagniteError() {
        logger('error', 'Magnite: failed to load script')
        window.pbjs.error = true
        document.dispatchEvent(new Event(Errors.MAGNITE_ERROR))
    }

    public initializeBidding(confs: IAdBiddingProviderConfig[]): void {

        const conf = confs.find((_) => _.client === AdBiddingProvider.MAGNITE)
        if (conf) {
            window.pbjs = window.pbjs || {}
            window.pbjs.que = window.pbjs.que || []
            DOMUtils.loadScript(this.URLPath, undefined, Magnite.OnMagniteError)
            logger(`debug`, `Initialize Magnite bidder: ${this.URLPath}`)
        }
    }

    public async requestAdsPromise(ads?: IAd[], slot?: any): Promise<any> {
        logger('info', 'optional ads passed to requestAdsPromise', ads)
        return new Promise((resolve: any, _): void => {
            // error loading Magnite/Prebid.js
            if (window.pbjs.error) {
                resolve()
            }
            document.addEventListener(Errors.MAGNITE_ERROR, () => {
                resolve()
            })

            window.pbjs.que.push(() => {
                const adUnitCodes = ads.map((ad) => ad.id)
                const gptSlotObjects = slot || ads.map((ad) => ad.slot)

                window.pbjs.rp.requestBids({
                    // specify ad IDs to request
                    adUnitCodes,
                    callback: () => {
                        /* istanbul ignore next */
                        logger('info', 'Magnite bidder has resolved')
                        resolve()
                    },
                    gptSlotObjects
                })
                window.setTimeout(resolve, this.failSafeTimeout)
                // can remove event listener safely as we are already in the pbjs.que
                /* istanbul ignore next */
                document.removeEventListener(Errors.MAGNITE_ERROR, () => {
                    resolve()
                })
            })
        })
    }
}

export default Magnite
